import { motion } from "framer-motion";

export const AppIcon = ({ app, onOpen, index = 0, size = "lg" }) => {
  const Icon = app.icon;
  const dim = size === "lg" ? "w-[68px] h-[68px]" : "w-8 h-8";
  const iconSize = size === "lg" ? 30 : 15;

  return (
    <motion.button
      type="button"
      data-testid={`app-icon-${app.id}`}
      onClick={() => onOpen(app)}
      initial={{ opacity: 0, scale: 0.6, y: 12 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{
        delay: 0.06 * index,
        type: "spring",
        stiffness: 260,
        damping: 20,
      }}
      whileTap={{ scale: 0.92 }}
      whileHover={{ y: -4 }}
      className="flex flex-col items-center gap-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60 rounded-3xl"
    >
      <div
        className={`${dim} rounded-[22px] grid place-items-center bg-gradient-to-b ${app.gradient} relative overflow-hidden`}
        style={{
          boxShadow: `0 12px 26px ${app.glow}, inset 0 1px 1px rgba(255,255,255,0.45), inset 0 -8px 16px rgba(0,0,0,0.18)`,
        }}
      >
        <div className="absolute inset-x-0 top-0 h-1/2 bg-white/20 rounded-t-[22px]" />
        <Icon size={iconSize} strokeWidth={2} className="text-white relative z-10 drop-shadow" />
      </div>
      {size === "lg" && (
        <span className="text-[11px] font-medium tracking-wide text-white/90 text-center leading-tight max-w-[76px]">
          {app.name}
        </span>
      )}
    </motion.button>
  );
};
